/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { InputAdornment, Snackbar, SnackbarContent, TextField } from '@mui/material';
import { withStyles } from '@mui/styles';
import SearchIcon from '@mui/icons-material/Search';
import * as React from 'react';
import { bulletinNumberSearchEndpoint } from '../common/constants';
import { loadFromLocalStorage } from '../common/localStorage';

interface Props {
    handleBulletinNumberSearch: Function,
    classes?: any,
    isLoading: any,
    LoadServiceBulletin: Function
    bulletinNumber: any
    UpdateBulletinNumber: Function
    StopLoading: Function
    ClearAll: Function
}
const styles = () => ({
    input: {
        backgroundColor: '#fff',
        height: 48,
        width: 312
    },
    root: {
        justifyContent: 'center'
    }
});

class BulletinNumberSearch extends React.Component<Props> {
    state = {
        productlist: [],
        selectedindex: 0,
        validationError: ''
    };
    handleChange = (event: any) => {
        this.props.UpdateBulletinNumber(event.target.value);
    };
    handlekeyPress = (event: any) => {
        if (event.key === 'Enter') {
            try {

                this.props.LoadServiceBulletin(event.target.value);
                this.props.ClearAll();
                const token: string = loadFromLocalStorage('AuthToken');
                const encodedToken = 'Bearer ' + token;
                const headerDict: any = {
                    'Authorization': encodedToken,
                    'Content-Type': 'application/json'
                };
                const endpoint = bulletinNumberSearchEndpoint;
                fetch(endpoint, {
                    headers: new Headers(headerDict),
                    body: JSON.stringify({
                        'BulletinNumber': event.target.value
                    }),
                    method: 'POST'
                })
                    .then(async (response: any) => {
                        const data = await response.json();

                        switch (response.status) {
                            case 200:
                                this.props.StopLoading();
                                console.log(data);
                                this.props.handleBulletinNumberSearch(data);
                                break;
                            case 400:
                                this.setState({ validationError: 'Error' });
                                this.props.StopLoading();
                                break;
                            case 404:
                                this.setState({ validationError: 'Product not found' });
                                this.props.StopLoading();
                                break;
                            default:
                                this.setState({ validationError: 'Product not found' });
                                this.props.StopLoading();
                        }
                    });
            }
            catch (e) { console.log(e); }
        }
    };

    handleClose = (value: any) => {
        this.props.StopLoading();
        this.setState({ selectedValue: value, open: false });
    };
    handleSnackBarClose = (event: any, reason: any) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ validationError: '' });
    };

    render() {
        const { classes, bulletinNumber } = this.props;
        return (
            <div >
                <TextField
                    name="bulletinNumber"
                    onChange={this.handleChange}
                    onKeyPress={this.handlekeyPress}
                    value={bulletinNumber}
                    variant="outlined"
                    InputProps={{
                        className: classes.input, startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                    InputLabelProps={{ shrink: false }}
                    label={bulletinNumber === '' ? 'Bulletin Number' : ''}
                    className="serialNumberinput"
                />
                <Snackbar
                    anchorOrigin={{
                        horizontal: 'left',
                        vertical: 'bottom'
                    }}
                    open={this.state.validationError !== ''}
                    autoHideDuration={5000}
                    onClose={this.handleSnackBarClose}
                >
                    <SnackbarContent
                        className="search-input-snackbar"
                        message={this.state.validationError}
                    />
                </Snackbar>
            </div>
        );
    }
}

export default
    ((withStyles(styles))(BulletinNumberSearch));

